import { FC } from 'react';
import { FfConnectionsView } from './ff-connections-view';
import { FriendsFamilyQrView } from './friends-family-qr-view';

export const FfConnectionsPanel: FC = () => (
  <>
    <div className="pt-4">
      <FriendsFamilyQrView />
    </div>
    <div className="pt-4">
      <FfConnectionsView />
    </div>
  </>
);
